import React from 'react';
import ListTemplate from '../../../Reusable_Components/ListTemplate';
import { API_ROUTES, API_DOMAIN } from '../../../Reusable_Components/Config/apiConfig';

const SalesPerformanceListDetails = () => {
  const columns = [
    { label: 'Sales Person', value: 'sales_person_name' },
    { label: 'Region', value: 'region_name' },
    { label: 'Period', value: 'period' },
    { label: 'Achieved Amount', value: 'achieved_amount' },
    { label: 'Access Details', value: (id) => <button onClick={() => handleAccessDetails(id)}>Access Details</button> },
  ];
  const handleAccessDetails = (id) => {
    const encodedId = btoa(id);
    window.location.href = '/lead/sales-performance/details/' + encodedId;
  };
  return <ListTemplate columns={columns} onAccessDetails={handleAccessDetails} fetchUrl={API_DOMAIN + API_ROUTES['salesPerformance']} />;
};

export default SalesPerformanceListDetails;